import { render, staticRenderFns } from "./actionBuilder.vue?vue&type=template&id=2624dff6"
import script from "./actionBuilder.vue?vue&type=script&lang=js"
export * from "./actionBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports